import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import "./MAgregarEditarSubOpcionesMenu.css";

function MAgregarEditarSubOpcionesMenu({
  origenComponente,
  registro = {},
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
  modo, //solo disponible para agregar persona
}) {
  const { ecv_u, cv_u } = useContext(Contexto);
  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    form: null,
    datosForm: {},
    respuestaActualizacion: {},
  });
  const [actualizaDatosTabla, setactualizaDatosTabla] = useState(null);

  useEffect(() => {
    console.log(origenComponente, registro, parametros, tipoEvento);
    const formularioAPI = _api_.f_crudOpcionMenu({
      parametros: {
        modo: "DSF",
        codigo: registro?.codigo,
        dscOpMenu: "",
        codClasificacion: "",
        codPrograma: "",
        codMenu: "",
        habilitado: "",
      },
      origen: origenComponente,
      timeout: 5000,
    });
    formularioAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          form: dPC.contenido.form,
        });
      }
    });
  }, []);

  useEffect(() => {
    // console.log(v_u.datosForm);
  }, [v_u.datosForm]);

  return (
    <div className={"MAgregarEditarSubOpcionesMenuCSS-cuerpo"}>
      {v_c.modal_mostrar && (
        <ModalInformacion
          estilos={v_c.modal_estilos}
          titulo={v_c.modal_titulo}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
            });
          }}>
          {v_c.preConfirmar_mostrar && (
            <_preconf_.PreConfirmacion
              texto={`${registro?.codigo == "" ? "¿Seguro que desea confirmar?" : "¿Seguro que desea confirmar los cambios?"}`}
              fBotonAceptar={() => {
                const actualizarDatosAPI = _api_.f_crudOpcionMenu({
                  parametros: {
                    modo: registro?.codigo == "" ? "INS" : "UPD",
                    codigo: registro?.codigo,
                    dscOpMenu: v_u.datosForm.dscOpMenu,
                    codClasificacion: v_u.datosForm.codClasificacion,
                    codPrograma: v_u.datosForm.codPrograma,
                    codMenu: v_u.datosForm.codMenu,
                    habilitado: v_u.datosForm.habilitado,
                  },
                  origen: origenComponente,
                  timeout: 5000,
                });
                actualizarDatosAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    _f_.asignar(ev_c, {
                      procesandoAccion_mostrar: false,
                      modal_titulo: "✅ Éxito",
                      postConfirmar_mostrar: true,
                    });
                    _f_.asignar(ev_u, {
                      respuestaActualizacion: dPC.contenido,
                    });
                  } else {
                    _f_.limpiarAsignacion(ev_c, Object.keys(v_c));
                  }
                });

                _f_.asignar(ev_c, {
                  preConfirmar_mostrar: false,
                  modal_titulo: "⏳ Procesando",
                  procesandoAccion_mostrar: true,
                });
              }}
              fBotonCancelar={() => {
                _f_.asignar(ev_c, { modal_mostrar: false });
              }}
            />
          )}
          {v_c.procesandoAccion_mostrar && <_procAcc_.ProcesandoAccion />}
          {v_c.postConfirmar_mostrar && (
            <_posconf_.PostConfirmacion
              texto={
                registro?.codigo == ""
                  ? `Se registro con éxito`
                  : `Se actualizó la información para la opción de menú ${registro?.["Descripción"]}`
              }
              fBotonDeAcuerdo={() => {
                fCerrarComponente?.();
                fActualizarTablaTotal?.(true);
              }}></_posconf_.PostConfirmacion>
          )}
        </ModalInformacion>
      )}
      <_form_.Formulario
        form={v_u.form ?? []}
        dext={setactualizaDatosTabla}
        onBlurCampos={{}}
        fObtenerDatosFormulario={(datos) => {
          _f_.asignar(ev_u, { datosForm: datos });
        }}></_form_.Formulario>

      <div className={"MAgregarEditarSubOpcionesMenuCSS-opciones"}>
        <_btn_.Boton
          texto={`${registro?.codigo ? "Actualizar" : "Aceptar"}`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_verde_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            console.log(v_u.datosForm);
            _f_.asignar(ev_c, {
              modal_mostrar: true,
              modal_estilos: { anchoMI: "30rem" },
              modal_titulo: "❗Confirmar Acción",
              preConfirmar_mostrar: true,
            });
          }}
        />
        <_btn_.Boton
          texto={`Cancelar`}
          tipo="btn-2"
          estilos={{
            anchoB2: "10rem",
            color: "var(--color_rojo_1)",
            fuente: "1rem",
          }}
          onClick={() => {
            fCerrarComponente?.();
          }}
        />
      </div>
    </div>
  );
}
export default MAgregarEditarSubOpcionesMenu;
